import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import { alertContext } from "../contexts/AlertProvider";
import Alert from "../Alert";
import refreshDriverApp from "../socket/RefreshDriverApp";
import PermissionGate from "../layout/PermissionGate";
import { formatDecimal } from "../utils/decimalFormat";

const EditOrder = () => {
  const [data, setData] = useState({});
  const [mounted, setMounted] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [merchants, setMerchants] = useState([]);
  const [branches, setBranches] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [areas, setAreas] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [streets, setStreets] = useState([]);
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const processData = (type, event, field) => {
    if (type === "text") {
      const value = event.target.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "select") {
      const value = event.value;
      const newData = { ...data };
      newData[field] = value;
      const selectedValue = event;
      const newSelectedData = { ...selectedData };
      newSelectedData[field] = selectedValue;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setSelectedData({ ...newSelectedData });
      setError({ ...newError });
      if (field === "merchantId") {
        setData(({ barnchId, ...rest }) => rest);
        setSelectedData(({ barnchId, ...rest }) => rest);
        setBranches([]);
      }
      if (field === "area") {
        setData(({ block, street, ...rest }) => rest);
        setSelectedData(({ block, street, ...rest }) => rest);
        setBlocks([]);
        setStreets([]);
      }
      if (field === "block") {
        setData(({ street, ...rest }) => rest);
        setSelectedData(({ street, ...rest }) => rest);
        setStreets([]);
      }
    }
    if (type === "date") {
      const value = moment(event).toDate();
      console.log(value);
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "radio") {
      const value = event;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
  };
  const editOrder = () => {
    const errors = {};
    if (data.merchantId === undefined || data.merchantId === "") {
      errors["merchantId"] = "Please select merchant";
    }
    if (data.branchId === undefined || data.branchId === "") {
      errors["branchId"] = "Please select branch";
    }
    if (data.driverId === undefined || data.driverId === "") {
      errors["driverId"] = "Please select driver";
    }
    if (data.orderDateTime === undefined || data.orderDateTime === "") {
      errors["orderDateTime"] = "Please select order time";
    }
    if (data.orderAmount === undefined || data.orderAmount === "") {
      errors["orderAmount"] = "Please enter order amount";
    }
    if (data.paymentType === undefined || data.paymentType === "") {
      errors["paymentType"] = "Please select payment type";
    }
    if (data.vehicleType === undefined || data.vehicleType === "") {
      errors["vehicleType"] = "Please select vehicle type";
    }
    if (data.customerName === undefined || data.customerName === "") {
      errors["customerName"] = "Please enter customer name";
    }
    if (data.customerPhone === undefined || data.customerPhone === "") {
      errors["customerPhone"] = "Please enter customer phone";
    }
    if (data.area === undefined || data.area === "") {
      errors["area"] = "Please select area";
    }
    if (data.block === undefined || data.block === "") {
      errors["block"] = "Please select block";
    }
    if (data.street === undefined || data.street === "") {
      errors["street"] = "Please select street";
    }
    if (data.building === undefined || data.building === "") {
      errors["building"] = "Please enter building name";
    }
    if (data.jadda === undefined || data.jadda === "") {
      errors["jadda"] = "Please enter jadda name";
    }
    if (data.apartment === undefined || data.apartment === "") {
      errors["apartment"] = "Please enter apartment name";
    }
    if (data.floor === undefined || data.floor === "") {
      errors["floor"] = "Please enter floor name";
    }
    if (data.editingReason === undefined || data.editingReason === "") {
      errors["editingReason"] = "Please select editing reason";
    }

    setError({ ...errors });
    if (
      errors.merchantId === undefined &&
      errors.branchId === undefined &&
      errors.driverId === undefined &&
      errors.orderDateTime === undefined &&
      errors.orderAmount === undefined &&
      errors.paymentType === undefined &&
      errors.vehicleType === undefined &&
      errors.customerName === undefined &&
      errors.customerPhone === undefined &&
      errors.area === undefined &&
      errors.block === undefined &&
      errors.street === undefined &&
      errors.building === undefined &&
      errors.jadda === undefined &&
      errors.apartment === undefined &&
      errors.floor === undefined &&
      errors.editingReason === undefined
    ) {
      setIsLoading(true);
      axios
        .put(`${process.env.REACT_APP_API_ENDPOINT}order/edit/${id}`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setIsLoading(false);
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              refreshDriverApp(data?.driverId);
            }
          }
        })
        .catch(console.error);
    }
  };
  const fetchMerchantList = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}merchant-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setMerchants(res.data.data);
          fetchDriverList();
        }
      })
      .catch(console.error);
  };
  const fetchBranchList = (merchantId) => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}branch-list/${merchantId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setBranches(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchDriverList = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}driver-list?latitude=${data?.pickup?.latitude}&longitude=${data?.pickup?.longitude}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setDrivers(res.data.data);
          fetchAreaList();
        }
      })
      .catch(console.error);
  };
  const fetchAreaList = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}location/areas`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setAreas(res.data.data);
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const fetchBlockList = (area) => {
    const areaName = encodeURIComponent(area?.value);
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}location/blocks/${areaName}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setBlocks(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchStreetList = (block) => {
    const areaName = encodeURIComponent(data?.area?.value);
    const blockName = encodeURIComponent(block?.value);
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}location/streets/${areaName}/${blockName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setStreets(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchOrderDetails = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}order/details/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          const data = res?.data?.data;
          data["editingReason"] = "";
          setData(data);
          fetchMerchantList();
          setTimeout(() => {
            setMounted(true);
          }, 1000);
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const calculateDeliveryFee = () => {
    setIsBusy(true);
    const startLatitude = data?.pickup?.latitude;
    const startLongitude = data?.pickup?.longitude;
    const endLatitude = data?.street?.latitude;
    const endLongitude = data?.street?.longitude;
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}location/calculate-delivery-fee?startLatitude=${startLatitude}&startLongitude=${startLongitude}&endLatitude=${endLatitude}&endLongitude=${endLongitude}&merchantId=${data?.merchantId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setData({
            ...data,
            time: res?.data?.data?.duration,
            distance: res?.data?.data?.distance,
            feeInt: res?.data?.data?.feeInt,
          });
          setIsBusy(false);
        }
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
          setIsBusy(false);
        }
      })
      .catch(console.error);
  };
  useEffect(() => {
    fetchOrderDetails();
  }, []);
  useEffect(() => {
    fetchBranchList(data?.orderMerchantId);
  }, [data?.orderMerchantId]);
  useEffect(() => {
    fetchBlockList(data?.area);
    fetchStreetList(data?.block);
  }, [areas]);
  useEffect(() => {
    if (mounted === true && data?.orderAmount > 0) {
      calculateDeliveryFee();
    }
  }, [data?.street, data?.orderAmount]);
  useEffect(() => {
    if (!(data?.pickup?.latitude && data?.pickup?.longitude)) return;
    fetchDriverList();
  }, [data?.pickup]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Edit Order
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <PermissionGate required={`edit_order`}>
                  <form
                    autoComplete="off"
                    id="editOrderForm"
                    encType="multipart/form-data"
                  >
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header"></div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Merchant
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  merchants
                                    ?.map((item) => ({
                                      value: item?._id,
                                      label: item?.merchantName,
                                    }))
                                    .find(
                                      (opt) =>
                                        opt.value === data?.orderMerchantId
                                    ) ?? null
                                }
                                onChange={(e) => {
                                  processData("select", e, "merchantId");
                                  fetchBranchList(e?.value);
                                }}
                                options={merchants?.map((item) => {
                                  return {
                                    value: item?._id,
                                    label: item?.merchantName,
                                  };
                                })}
                                placeholder="Select merchant"
                              />
                              {error.merchantId !== undefined &&
                              error.merchantId !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.merchantId}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Branch
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  branches
                                    ?.map((item) => ({
                                      value: item?._id,
                                      label: item?.name,
                                    }))
                                    .find(
                                      (opt) => opt.value === data?.branchId
                                    ) ?? null
                                }
                                onChange={(e) => {
                                  processData("select", e, "branchId");
                                }}
                                options={branches?.map((item) => {
                                  return {
                                    value: item?._id,
                                    label: item?.name,
                                  };
                                })}
                                placeholder="Select branch"
                              />
                              {error.branchId !== undefined &&
                              error.branchId !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.branchId}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Driver
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  drivers
                                    ?.map((item) => ({
                                      value: item?._id,
                                      label: item?.name,
                                    }))
                                    .find(
                                      (opt) => opt.value === data?.driverId
                                    ) ?? null
                                }
                                onChange={(e) => {
                                  processData("select", e, "driverId");
                                }}
                                options={drivers?.map((item) => {
                                  return {
                                    value: item?._id,
                                    label: item?.name,
                                  };
                                })}
                                placeholder="Select driver"
                              />
                              {error.driverId !== undefined &&
                              error.driverId !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.driverId}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Order Date and Time
                              </label>

                              <Flatpickr
                                options={{
                                  enableTime: true,
                                  dateFormat: "d-m-Y H:i",
                                  time_24hr: true,
                                }}
                                value={data?.orderDateTime ?? ""}
                                onChange={([orderDateTime]) => {
                                  processData(
                                    "date",
                                    orderDateTime,
                                    "orderDateTime"
                                  );
                                }}
                                className="form-control"
                                placeholder="Pick date"
                              />
                              {error.orderDateTime !== undefined &&
                              error.orderDateTime !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.orderDateTime}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Order Amount
                              </label>
                              <input
                                type="number"
                                className="form-control add-delivery-company-field no-spinner"
                                placeholder="0.00"
                                value={data?.orderAmount ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "orderAmount");
                                }}
                              />
                              {error.orderAmount !== undefined &&
                              error.orderAmount !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.orderAmount}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Reason for Editing the Order
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={selectedData?.editingReason ?? null}
                                onChange={(e) => {
                                  processData("select", e, "editingReason");
                                }}
                                options={[
                                  {
                                    label: "Edit date",
                                    value: "Edit date",
                                  },
                                  {
                                    label: "Extra km",
                                    value: "Extra km",
                                  },
                                  {
                                    label: "Area change",
                                    value: "Area change",
                                  },
                                  {
                                    label: "Order amount change",
                                    value: "Order amount change",
                                  },
                                  {
                                    label: "Return order",
                                    value: "Return order",
                                  },
                                  {
                                    label: "Customer didn't pay",
                                    value: "Customer didn't pay",
                                  },
                                  {
                                    label: "Area change and return order",
                                    value: "Area change and return order",
                                  },
                                  {
                                    label: "Double trip",
                                    value: "Double trip",
                                  },
                                  {
                                    label: "Cash return",
                                    value: "Cash return",
                                  },
                                  {
                                    label: "Triple trip",
                                    value: "Triple trip",
                                  },
                                  {
                                    label: "Cash collection",
                                    value: "Cash collection",
                                  },
                                ]}
                                placeholder="Select reason"
                              />
                              {error.editingReason !== undefined &&
                              error.editingReason !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.editingReason}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12 mb-3">
                              <label className="form-label required">
                                Payment Type
                              </label>
                              <div className="fv-row">
                                {/*begin::Radio group*/}
                                <div
                                  className="btn-group w-100"
                                  data-kt-buttons="true"
                                  data-kt-buttons-target="[data-kt-button]"
                                >
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.paymentType === "Cash on Delivery"
                                        ? "btn btn-outline btn-md bg-primary text-white"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="Cash on Delivery"
                                      onClick={() => {
                                        processData(
                                          "radio",
                                          "Cash on Delivery",
                                          "paymentType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Cash on Delivery
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.paymentType === "Paid"
                                        ? "btn btn-outline btn-md bg-primary text-white"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="Paid"
                                      onClick={() => {
                                        processData(
                                          "radio",
                                          "Paid",
                                          "paymentType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Paid
                                  </label>
                                  {/*end::Radio*/}
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.paymentType === "Payment Link"
                                        ? "btn btn-outline btn-md bg-primary text-white"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="Payment Link"
                                      onClick={() => {
                                        processData(
                                          "radio",
                                          "Payment Link",
                                          "paymentType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Payment Link
                                  </label>
                                  {/*end::Radio*/}
                                </div>
                                {/*end::Radio group*/}
                              </div>
                              {error.paymentType !== undefined &&
                              error.paymentType !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.paymentType}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12 mb-3">
                              <label className="form-label required">
                                Vehicle Type
                              </label>
                              <div className="fv-row">
                                {/*begin::Radio group*/}
                                <div
                                  className="btn-group w-100"
                                  data-kt-buttons="true"
                                  data-kt-buttons-target="[data-kt-button]"
                                >
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.vehicleType === "Car"
                                        ? "btn btn-outline btn-md bg-primary text-white"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="Car"
                                      onClick={() => {
                                        processData(
                                          "radio",
                                          "Car",
                                          "vehicleType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Car
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.vehicleType === "Motorcycle"
                                        ? "btn btn-outline btn-md bg-primary text-white"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="Motorcycle"
                                      onClick={() => {
                                        processData(
                                          "radio",
                                          "Motorcycle",
                                          "vehicleType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Motorcycle
                                  </label>
                                  {/*end::Radio*/}
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.vehicleType === "Any"
                                        ? "btn btn-outline btn-md bg-primary text-white"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="Any"
                                      onClick={() => {
                                        processData(
                                          "radio",
                                          "Any",
                                          "vehicleType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Any
                                  </label>
                                  {/*end::Radio*/}
                                </div>
                                {/*end::Radio group*/}
                              </div>
                              {error.vehicleType !== undefined &&
                              error.vehicleType !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleType}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label required">
                                Customer Name
                              </label>
                              <input
                                type="text"
                                autoComplete="none"
                                className="form-control add-delivery-company-field"
                                placeholder="Enter name"
                                value={data?.customerName ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "customerName");
                                }}
                              />
                              {error.customerName !== undefined &&
                              error.customerName !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.customerName}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label required">
                                Customer Phone
                              </label>
                              <input
                                type="text"
                                autoComplete="none"
                                className="form-control add-delivery-company-field"
                                placeholder="Enter phone no"
                                value={data?.customerPhone ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "customerPhone");
                                }}
                              />
                              {error.customerPhone !== undefined &&
                              error.customerPhone !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.customerPhone}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Area
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  areas
                                    ?.map((item) => ({
                                      value: item?.value,
                                      label: item?.value,
                                    }))
                                    .find(
                                      (opt) => opt.value === data?.area?.value
                                    ) ?? null
                                }
                                onChange={(e) => {
                                  processData("select", e, "area");
                                  fetchBlockList(e?.value);
                                }}
                                options={areas?.map((item) => {
                                  return {
                                    value: item,
                                    label: item?.value,
                                  };
                                })}
                                placeholder="Select area"
                              />
                              {error.area !== undefined && error.area !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.area}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Block
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  blocks
                                    ?.map((item) => ({
                                      value: item?.value,
                                      label: item?.value,
                                    }))
                                    .find(
                                      (opt) => opt.value === data?.block?.value
                                    ) ?? null
                                }
                                onChange={(e) => {
                                  processData("select", e, "block");
                                  fetchStreetList(e?.value);
                                }}
                                options={blocks?.map((item) => {
                                  return {
                                    value: item,
                                    label: item?.value,
                                  };
                                })}
                                placeholder="Select block"
                              />
                              {error.block !== undefined &&
                              error.block !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.block}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Street
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  streets
                                    ?.map((item) => ({
                                      value: item?.value,
                                      label: item?.value,
                                    }))
                                    .find(
                                      (opt) => opt.value === data?.street?.value
                                    ) ?? null
                                }
                                onChange={(e) => {
                                  processData("select", e, "street");
                                }}
                                options={streets?.map((item) => {
                                  return {
                                    value: item,
                                    label: item?.value,
                                  };
                                })}
                                placeholder="Select street"
                              />
                              {error.street !== undefined &&
                              error.street !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.street}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Building
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Building name"
                                value={data?.building ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "building");
                                }}
                              />
                              {error.building !== undefined &&
                              error.building !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.building}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Jadda
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Jadda Details"
                                value={data?.jadda ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "jadda");
                                }}
                              />
                              {error.jadda !== undefined &&
                              error.jadda !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.jadda}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Apartment
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Apartment Details"
                                value={data?.apartment ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "apartment");
                                }}
                              />
                              {error.apartment !== undefined &&
                              error.apartment !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.apartment}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Floor
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Floor Details"
                                value={data?.floor ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "floor");
                                }}
                              />
                              {error.floor !== undefined &&
                              error.floor !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.floor}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Description
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Short Description"
                                value={data?.description ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "description");
                                }}
                              />
                              {error.description !== undefined &&
                              error.description !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.description}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Notes
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Short Note"
                                value={data?.notes ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "notes");
                                }}
                              />
                              {error.notes !== undefined &&
                              error.notes !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.notes}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <tbody>
                                    <tr>
                                      <th>Distance</th>
                                      <td>{data?.distance ?? 0} Km</td>
                                    </tr>
                                    <tr>
                                      <th>Time</th>
                                      <td>{data?.time ?? 0} min</td>
                                    </tr>
                                    <tr>
                                      <th>Fee</th>
                                      <td>
                                        {formatDecimal(data?.feeInt)}{" "}
                                        {data?.currency ?? "KWD"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <button
                            disabled={isBusy === true ? true : false}
                            type="button"
                            className="btn btn-primary me-2"
                            id="editOrderBtn"
                            onClick={() => {
                              editOrder();
                            }}
                          >
                            {isBusy && (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            )}

                            <span className="indicator-label ms-2">
                              Update Order
                            </span>
                          </button>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                  </form>
                </PermissionGate>
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default EditOrder;
